export const globalAppConfig = {
    MAX_FORM_FIELD_LENGTH: 256,
    // MAPBOX for Map
    MAP_BOX_ACCESS_TOKEN:
        "pk.eyJ1Ijoibmlja2RyZWlsaW5nIiwiYSI6ImNreWM1bHJ0YTBtMjMyb28xcDUxbTlhdG8ifQ.HC1ZRxJzHaHyun8p5GEFSQ",
    // ArcGIS for Detailed Maps
    ARC_GIS_IMAGERY_URL:
        "https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/arcgis/imagery?token=AAPTaVb88bHZwT0jqmEBUnFhnKw..UFE9WFXN6D8zus6AkhLdWsMt11WDyJPbb5EiYhHMZYt33kyN7W6Q7CJT8wgRNucG9GalBaFQoGOJC6ADmQ6ZeQB4qEG2g2-By6LmCG36BsPZrzJKsYD5GRmzLEuX6t6LMvDhXXRfkILZqBEHpM-rfuUBoafnDt1FtDVFKszbEbuujNxFMqi3-4YpPu6gpYeqOER17GkrW5kMJPNSch9vl4j3-joyTe1DDmJok0Poml-K34R7khVkGufnQOcVBjL0Thq9AT1_XHIgfaQB",
    MIXPANEL_API_TOKEN_DEV: "7a07808e45fe961dadd67fa639567835",
    MIXPANEL_API_TOKEN_PROD: "de464b6e35563d97d3d203cc084f1883",
    FINGERPRINTJS_API_KEY: "c0lQB4i0VLCPfYbKhVUC",
    NOTIFICATION_DURATION: 4.5,
    uuid: "plot-app-test-uuid",
    MUI_X_LICENSE_KEY:
        "ac24e0b3689ba60698db561bc9f32d86Tz0xMzAyNDIsRT0xODE1MjYzOTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTMsQVQ9bXVsdGksS1Y9Mg==",

    //Anonymous User Limits Before Sign In
    PROJECT_SEARCH_LIMIT: 7,
    PROJECT_SEARCH_RESULTS_LIMIT: 70,
    TEAM_SEARCH_LIMIT: 5,
    TEAM_SEARCH_RESULTS_LIMIT: 50,

    ACCEPTED_UPLOAD_FILE_TYPES:
        "image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip, .tiff, .tif, .xml, video/*,audio/*",
    MAX_UPLOAD_FILE_SIZE: 10 * 1024 * 1024, // 10MB
};

import { LicenseInfo, muiXTelemetrySettings } from "@mui/x-license";
LicenseInfo.setLicenseKey(globalAppConfig.MUI_X_LICENSE_KEY);
muiXTelemetrySettings.disableTelemetry();
